import type { ReactNode } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { fontSize, gridSize } from '@atlassian/jira-common-styles/src';
import { ff } from '@atlassian/jira-feature-flagging';

export const HEADER_HEIGHT = 4.5 * gridSize;
export const HEADER_CELL_HEIGHT = 3.5 * gridSize;

/* This shadow would normally go on the thead or the tr, but Safari has a bug and won't render it there */
// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderCellWithBorder = styled.th({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	boxShadow: `inset 0 -2px 0 ${token('color.border', colors.N40)}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${HEADER_HEIGHT}px`,
	boxSizing: 'border-box',
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ColumnName = styled.span(
	{
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		fontSize: `${fontSize}px`,
		lineHeight: '16px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	() =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		ff('nin-resizable-columns_8z4eo') && {
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
);

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SortIcon = styled.span<{ isIconPersistent: boolean }>({
	marginLeft: token('space.050', '4px'),
	marginRight: token('space.negative.025', '-2px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	opacity: ({ isIconPersistent }) => (isIconPersistent ? 1 : 0),
	transition: 'opacity 100ms ease-in-out',
	lineHeight: '16px',
});

// TODO: Cleanup this file with jsv-one-issue-table-spreadsheet-ui_ygrnf
// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderCell = styled(HeaderCellWithBorder)<{
	columnWidth?: number;
	minColumnWidth?: number;
	children?: ReactNode;
	alignRight?: boolean;
}>(
	{
		// Need position:relative here so the drop indicator (which uses position:absolute)
		// can be correctly positioned inside
		position: 'relative',
		padding: `0 0 ${token('space.025', '2px')} 0`,
		verticalAlign: 'middle',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ columnWidth }) => columnWidth && { width: `${columnWidth}px` },
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ minColumnWidth }) => minColumnWidth && { minWidth: `${minColumnWidth}px` },
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ alignRight }) => alignRight && { textAlign: 'right' },
);

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentContainer = styled.div<{
	isIconPersistent: boolean;
}>(
	{
		display: 'inline-flex',
		alignItems: 'center',
		whiteSpace: 'nowrap',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		height: `${HEADER_CELL_HEIGHT}px`,
		fontWeight: '500',
		borderRadius: '3px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isIconPersistent }) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		isIconPersistent && { backgroundColor: token('elevation.surface.sunken', colors.N20) },
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	() =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		ff('jsv-one-issue-table-spreadsheet-ui_ygrnf')
			? {
					padding: `0 ${token('space.025', '2px')}`,
				}
			: {
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					color: token('color.text', colors.N500),
					padding: `0 ${token('space.100', '8px')}`,
				},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	() =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		ff('nin-resizable-columns_8z4eo') && {
			maxWidth: '100%',
		},
);
